import * as z from "zod";

export const enableRecoverBilling = {
  name: "enableRecoverBilling" as const,
  input: z.object({ returnPath: z.string().optional() }),
  output: z.object({
    status: z.enum([
      "billing_already_enabled",
      "billing_enabled",
      "shopify_confirmation_required",
    ]),
    confirmationUrl: z.string().optional(),
    errorMessage: z.string().optional(),
  }),
};
